$(document).ready(function() {
  if($('body').hasClass('new-pdp')){
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        loop:false,
        fade: false,
        asNavFor: '.slider-nav',
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1.5,
              infinite: false,
            }
          }
        ]
    });
  }else{
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        loop:false,
        fade: false,
        asNavFor: '.slider-nav',
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1.4,
              infinite: false,
            }
          }
        ]
    });
  }
  $('.slider-nav').each(function () {
    var $nav = $(this);
    var customCount = parseInt($nav.data('thumbs-to-show'), 10);
    var hasCustomCount = !isNaN(customCount) && customCount > 0;
    var desktopShow = hasCustomCount ? customCount : 8;
    var tabletShow = hasCustomCount ? customCount : 5;
    var mobileShow = hasCustomCount ? customCount : 8;

    $nav.slick({
        slidesToShow: desktopShow,
        slidesToScroll: 1,
        horizontal:true,
        centerMode: false,
        centerPadding: '50px',
        arrows: true,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        prevArrow: $('.custom-prev'),
        nextArrow: $('.custom-next'),
        horizontalSwiping:true,
        responsive: [
        {
          breakpoint: 999,
          settings: {
            horizontal: false,
            slidesToShow: tabletShow,
          }
        },
        {
          breakpoint: 750,
          settings: {
            horizontal: false,
            slidesToShow: mobileShow,
          }
        }
        ]
    });
  });
  // $('.slider-nav').slick({
  //     slidesToShow: 8,
  //     slidesToScroll: 1,
  //     horizontal:true,
  //     centerMode: false,
  //     centerPadding: '50px',
  //     arrows: true,
  //     asNavFor: '.slider-for',
  //     dots: false,
  //     focusOnSelect: true,
  //     prevArrow: $('.custom-prev'),
  //     nextArrow: $('.custom-next'),
  //     horizontalSwiping:true,
  //     responsive: [
  //     {
  //       breakpoint: 999,
  //       settings: {
  //         horizontal: false,
  //         slidesToShow: 5,
  //       }
  //     },
  //     {
  //       breakpoint: 750,
  //       settings: {
  //         horizontal: false,
  //         slidesToShow: 8,
  //       }
  //     }
  //     ]
  // });
  
  $(".meal-variants-row").appendTo("#product_vbox");
    
      });